/**
 * Delivery countdown and dated track.
 *
 * Dates are computed in the browser so they read from the visitor's own today
 * and their own timezone, rather than freezing at whatever moment the page was
 * rendered or cached.
 *
 * Working days only: a Saturday order does not dispatch on Sunday, and quoting
 * a weekend arrival is the kind of small lie that turns into a support ticket.
 *
 * The block ships hidden and is revealed once the first calculation lands, so a
 * half-written delivery promise is never on screen. With JS off it stays
 * hidden, which is the honest failure - the alternative is a countdown frozen
 * at whatever the server thought the time was.
 */
(function () {
  "use strict";

  var box = document.querySelector("[data-calmy-delivery]");
  if (!box) return;

  var lead = box.querySelector("[data-calmy-delivery-lead]");
  var shipEl = box.querySelector("[data-calmy-delivery-ship]");
  var arriveEl = box.querySelector("[data-calmy-delivery-arrive]");

  var num = function (k, d) { var v = parseInt(box.getAttribute(k), 10); return isNaN(v) ? d : v; };
  var cutoff = num("data-cutoff", 15);
  var shipMin = num("data-ship-min", 1);
  var shipMax = num("data-ship-max", 2);
  var delMin = num("data-deliver-min", 3);
  var delMax = num("data-deliver-max", 7);
  var copy = box.getAttribute("data-copy") || "Order within [countdown] and you will have it by [date]";

  function addWorkingDays(from, days) {
    var d = new Date(from);
    var left = days;
    while (left > 0) {
      d.setDate(d.getDate() + 1);
      var wd = d.getDay();
      if (wd !== 0 && wd !== 6) left -= 1;
    }
    return d;
  }

  function fmt(d) {
    return d.toLocaleDateString(document.documentElement.lang || "en-GB", { day: "numeric", month: "short" });
  }

  function range(a, b) {
    return fmt(a) === fmt(b) ? fmt(a) : fmt(a) + " - " + fmt(b);
  }

  function tick() {
    var now = new Date();

    var next = new Date(now);
    next.setHours(cutoff, 0, 0, 0);
    if (next.getTime() <= now.getTime()) next.setDate(next.getDate() + 1);

    var ms = next.getTime() - now.getTime();
    var h = Math.floor(ms / 3600000);
    var m = Math.floor((ms % 3600000) / 60000);
    var sec = Math.floor((ms % 60000) / 1000);
    var clock = h + "h " + String(m).padStart(2, "0") + "m " + String(sec).padStart(2, "0") + "s";

    var shipFrom = addWorkingDays(now, shipMin);
    var shipTo = addWorkingDays(now, shipMax);
    var arriveFrom = addWorkingDays(now, delMin);
    var arriveTo = addWorkingDays(now, delMax);

    if (lead) {
      lead.innerHTML = copy
        .replace(/\[countdown\]/g, '<span class="cdel__clock">' + clock + "</span>")
        .replace(/\[date\]/g, "<b>" + fmt(arriveTo) + "</b>");
    }
    if (shipEl) shipEl.textContent = range(shipFrom, shipTo);
    if (arriveEl) arriveEl.textContent = range(arriveFrom, arriveTo);

    box.hidden = false;
  }

  tick();
  /* One second is what a countdown needs; it stops when the tab is hidden, so
     a backgrounded product page is not burning a timer for nothing. */
  var timer = window.setInterval(tick, 1000);
  document.addEventListener("visibilitychange", function () {
    if (document.hidden) { window.clearInterval(timer); timer = null; }
    else if (!timer) { tick(); timer = window.setInterval(tick, 1000); }
  });
})();
